<template>
  <div v-if="Object.keys(errors).length" class="alert alert-danger">
    <div v-for="(error, index) in errors" :key="index">{{ error[0] }}</div>
  </div>
</template>
<script>
export default {
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  }
};
</script>
